module.exports = __webpack_public_path__ + "img/icon-stockpicker-training@2x.37149a89.png";